import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=921784c8&scoped=true&"
import script from "./photoAlbum.vue?vue&type=script&lang=js&"
export * from "./photoAlbum.vue?vue&type=script&lang=js&"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=921784c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921784c8",
  null
  
)

export default component.exports